import { Property } from "@app/models/Property";
import { Inject, Injectable } from "@angular/core";
import { WindowToken } from "@app/util/window.token";

/**
 * Created by mac90082 on 9/21/16.
 */

enum SourceType {
    NORMFILEURI = 0,
    NORMNATIVEURI = 1,
    FASTFILEURI = 2,
    FASTNATIVEURI = 3,
    BASE64 = 4,
}

enum ReturnType {
    BLOCKS = 0,
    LINES = 1,
    WORDS = 2,
    ALL = 3
}

@Injectable({ providedIn: "root" })
export class CouponCaptureService {
    imageBase64 = '';
    imageToSave = '';
    accountNumber = '';
    routingNumber = '';

    constructor(@Inject(WindowToken) private window) { }

    setImageBase64(imageName) {
        this.imageBase64 = imageName;
    }

    getImageBase64() {
        return this.imageBase64;
    }

    setImageToSave(newObj) {
        this.imageToSave = newObj;
    }

    getImageToSave() {
        return this.imageToSave;
    }

    setAccountNumber(newObj) {
        this.accountNumber = newObj;
    }

    getAccountNumber() {
        return this.accountNumber;
    }

    setRoutingNumber(newObj) {
        this.routingNumber = newObj;
    }

    getRoutingNumber() {
        return this.routingNumber;
    }
}

